import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * 単行テキストリンク表示フィールド
 *【内容:content:string】
 *【表示条件:visible:boolean】
 *【ラベル内容:labelContent:string】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-single-link-display-field',
  templateUrl: './single-link-display-field.html',
  styles: [`
    .single-link {
      color: #5b68d2;
    }
  `]
})
export class SingleLinkDisplayField extends BaseWidget {
  /**
   * 内容
   */
  @Input() content:string

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * ラベル内容
   */
  @Input() labelContent:string

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/form/single-link-display-field/single-link-display-field.component.ts